import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=7d9886e0&scoped=true"
import script from "./Copyright.vue?vue&type=script&lang=ts"
export * from "./Copyright.vue?vue&type=script&lang=ts"
import style0 from "./Copyright.vue?vue&type=style&index=0&id=7d9886e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9886e0",
  null
  
)

export default component.exports